<template>
  <div>
    <!-- <Header /> -->
    <div class="flex flex-col lg:flex-row">
      <SideBar />
      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="p-10">
          <div>
            <!-- Tab Buttons -->
            <div class="rounded flex gap-4 cursor-pointer">
              <p
                class="text-sm font-bold"
                :class="[
                  activeTab === 'email'
                    ? 'border-b-2 border-blues text-gray-600'
                    : 'text-gray-600',
                ]"
                @click="setTab('email')"
              >
                Email Credentials
              </p>
              <p
                class="text-sm font-bold"
                :class="[
                  activeTab === 'google'
                    ? 'border-b-2 border-blues text-gray-600  '
                    : 'text-gray-600',
                ]"
                @click="setTab('google')"
              >
                Meeting Credentials
              </p>
            </div>

            <!-- Tab Content start -->
            <div class="mt-4">
              <div v-if="activeTab === 'email'" class="flex flex-col gap-5">
                <div class="flex justify-end">
                  <button
                    @click="this.addEmail = true"
                    class="bg-[#18469d] text-white font-semibold text-xs px-4 py-2 rounded-xl"
                  >
                    Add
                  </button>
                </div>

                <!-- table -->
                <div class="overflow-x-auto">
                  <table
                    class="table-auto w-full border border-gray-200 rounded-lg"
                  >
                    <thead class="bg-blues text-white text-sm">
                      <tr>
                        <th
                          class="p-2 text-center whitespace-nowrap border border-gray-200"
                        >
                          S NO
                        </th>
                        <th
                          class="p-2 text-center whitespace-nowrap border border-gray-200"
                        >
                          Type
                        </th>
                        <th
                          class="p-2 text-center whitespace-nowrap border border-gray-200"
                        >
                          Email
                        </th>
                        <th
                          class="p-2 text-center whitespace-nowrap border border-gray-200"
                        >
                          Port
                        </th>
                        <th
                          class="p-2 text-center whitespace-nowrap border border-gray-200"
                        >
                          Published
                        </th>
                        <th
                          class="p-2 text-center whitespace-nowrap border border-gray-200"
                        >
                          Edit
                        </th>
                      </tr>
                    </thead>

                    <!-- Data Rows -->
                    <tbody v-if="datas.length">
                      <tr
                        v-for="(project, index) in datas"
                        :key="project.id"
                        class="text-sm even:bg-gray-50 hover:bg-gray-100 transition text-center"
                      >
                        <td class="p-2 border border-gray-200">
                          <p class="text-blues font-medium">
                            {{ index + 1 }}
                          </p>
                        </td>

                        <td
                          class="p-2 border border-gray-200 whitespace-nowrap"
                        >
                          <p class="text-gray-700">
                            {{ project.type || "NA" }}
                          </p>
                        </td>

                        <td
                          class="p-2 border border-gray-200 whitespace-nowrap"
                        >
                          <p class="text-gray-700">
                            {{ project.email || "NA" }}
                          </p>
                        </td>

                        <td
                          class="p-2 border border-gray-200 whitespace-nowrap"
                        >
                          <p class="text-gray-700">
                            {{ project.port || "NA" }}
                          </p>
                        </td>

                        <td
                          class="p-2 border border-gray-200 whitespace-nowrap"
                        >
                          <label
                            class="relative inline-block w-12 h-7 sm:w-10 sm:h-5"
                          >
                            <input
                              type="checkbox"
                              class="peer opacity-0 w-0 h-0"
                              :checked="project.is_active"
                              @change="handleToggle(project)"
                            />
                            <!-- Track -->
                            <span
                              :class="[
                                'absolute cursor-pointer top-0 left-0 right-0 bottom-0 rounded-full transition duration-300',
                                project.is_active
                                  ? 'bg-green-400'
                                  : 'bg-red-500',
                              ]"
                            ></span>

                            <!-- Knob -->
                            <span
                              :class="[
                                'absolute border border-white rounded-full transition duration-300',
                                'bottom-[5px] left-[4px] h-5 w-5 sm:h-[15px] sm:w-[15px] sm:bottom-[2.5px] sm:left-[2px]',
                                project.is_active
                                  ? 'translate-x-[22px] sm:translate-x-[18px] bg-green-600'
                                  : 'translate-x-0 bg-white',
                              ]"
                            ></span>
                          </label>

                          <!-- Popup -->
                          <div
                            v-if="showPopup"
                            class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
                          >
                            <div
                              class="lg:w-[40%] 2xl:w-[30%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
                            >
                              <div
                                class="w-full flex flex-col relative rounded-2xl"
                              >
                                <div class="w-full flex flex-col gap-8">
                                  <h1
                                    v-if="this.checkbox_status == false"
                                    class="font-bold text-sm text-red-400 text-center"
                                  >
                                    Do You Want To Deactivate This User
                                    <span class="text-sm text-blues">{{
                                      dep_email
                                    }}</span
                                    >?
                                  </h1>
                                  <h1
                                    v-else
                                    class="font-bold text-sm text-green-400 text-center"
                                  >
                                    Do You Want To Activate This User
                                    <span class="text-sm text-blues">{{
                                      dep_email
                                    }}</span
                                    >?
                                  </h1>
                                  <div class="flex justify-center gap-4">
                                    <button
                                      @click="cancelToggle"
                                      class="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded-md text-sm"
                                    >
                                      No
                                    </button>
                                    <button
                                      @click="confirmToggle"
                                      class="bg-blues hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm"
                                    >
                                      Yes
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>

                        <td
                          class="p-2 border border-gray-200 whitespace-nowrap"
                        >
                          <button @click="openEditPopup(project.id)">
                            <img
                              src="@/assets/new/medit.png"
                              alt="Edit"
                              class="w-6 h-6 p-1 rounded"
                            />
                          </button>
                        </td>
                      </tr>
                    </tbody>

                    <!-- Empty State -->
                    <tbody v-else>
                      <tr>
                        <td colspan="6" class="text-center py-6 text-gray-500">
                          No Data Found
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-if="activeTab === 'google'" class="flex flex-col gap-5">
                <div class="flex justify-end">
                  <button
                    @click="this.addMeet = true"
                    class="bg-[#18469d] text-white font-semibold text-xs px-4 py-2 rounded-xl"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>

            <!-- tab end -->

            <!-- Add email popup -->
            <div
              v-if="this.addEmail"
              class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
            >
              <div
                class="lg:w-[30%] bg-white rounded-xl p-5 overflow-y-auto max-h-[600px]"
              >
                <div class="flex items-center justify-center">
                  <h3 class="text-xl font-bold text-blues text-center">
                    Add Email Credentials
                  </h3>
                </div>

                <div
                  class="w-full mt-4 flex flex-col p-6 relative border-gray-100 rounded-2xl"
                >
                  <div class="w-full">
                    <form
                      ref="createTeamRef"
                      @submit.prevent="createSyllabus"
                      class="flex flex-col gap-2 text-xs md:text-sm lg:text-base h-full"
                    >
                      <div class="flex flex-col gap-3">
                        <label for="Types" class="text-sm flex gap-2"
                          >Types
                        </label>

                        <select
                          id="Types"
                          class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                        >
                          <option value="" selected>Select Type</option>
                          <option value="IMAP">IMAP</option>
                          <option value="SMTP">SMTP</option>
                          <option value="POP3">POP3</option>
                        </select>
                      </div>
                      <div class="w-full flex flex-col gap-2">
                        <label for="email" class="text-left"
                          >Email <span class="text-red-400">*</span></label
                        >

                        <input
                          required
                          id="email"
                          type="email"
                          placeholder="Email"
                          class="border border-gray-200 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                        />
                      </div>

                      <div class="w-full flex flex-col gap-2">
                        <label for="password" class="text-left"
                          >Password <span class="text-red-400">*</span></label
                        >

                        <input
                          required
                          id="password"
                          type="password"
                          placeholder="Password"
                          class="border border-gray-200 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                        />
                      </div>
                      <div class="flex flex-col gap-3">
                        <label for="Port" class="text-sm flex gap-2"
                          >Port
                        </label>

                        <select
                          id="Port"
                          class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                        >
                          <option value="" selected>Select port</option>
                          <option value="465">465 (SSL)</option>
                          <option value="587">587 (TLS)</option>
                          <option value="25">25 (Unsecured)</option>
                        </select>
                      </div>
                      <div class="flex mt-6 items-center gap-2">
                        <input type="checkbox" id="Published" />
                        <label for="Published" class="text-sm">Published</label>
                      </div>
                      <div class="flex justify-center pb-4 mt-3 gap-10">
                        <button
                          @click="this.addEmail = false"
                          class="border text-gray-500 rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                        >
                          Close
                        </button>
                        <div class="flex justify-end items-center gap-3">
                          <button
                            type="submit"
                            :disabled="disable_submit == true"
                            :class="
                              this.disable_submit == true
                                ? 'bg-gray-200 text-black cursor-not-allowed'
                                : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                            "
                            class="rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                          >
                            Submit
                          </button>
                          <img
                            v-if="disable_submit"
                            src="@/assets/loading.gif"
                            alt="loading"
                            class="w-6 h-6 object-contain"
                          />
                        </div>

                        <!-- <button
                          type="submit"
                          class="text-white bg-blues rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                        >
                          Submit
                        </button> -->
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <!-- Edit email popup -->
            <div
              v-if="this.editEmail"
              class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
            >
              <div
                class="lg:w-[30%] bg-white rounded-xl p-5 overflow-y-auto max-h-[600px]"
              >
                <div class="flex items-center justify-center">
                  <h3 class="text-xl font-bold text-blues text-center">
                    Edit Email Credentials
                  </h3>
                </div>

                <div
                  class="w-full mt-4 flex flex-col p-6 relative border-gray-100 rounded-2xl"
                >
                  <div class="w-full">
                    <form
                      ref="createTeamRef"
                      @submit.prevent="createSyllabus"
                      class="flex flex-col gap-2 text-xs md:text-sm lg:text-base h-full"
                    >
                      <div class="flex flex-col gap-3">
                        <label for="Types" class="text-sm flex gap-2"
                          >Types
                        </label>

                        <select
                          id="Types"
                          v-model="types"
                          class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                        >
                          <option value="" selected>Select Type</option>
                          <option value="IMAP">IMAP</option>
                          <option value="SMTP">SMTP</option>
                          <option value="POP3">POP3</option>
                        </select>
                      </div>
                      <div class="w-full flex flex-col gap-2">
                        <label for="email" class="text-left"
                          >Email <span class="text-red-400">*</span></label
                        >

                        <input
                          required
                          id="email"
                          type="email"
                          placeholder="Email"
                          v-model="email"
                          class="border border-gray-200 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                        />
                      </div>

                      <div class="w-full flex flex-col gap-2">
                        <label for="password" class="text-left"
                          >Password <span class="text-red-400">*</span></label
                        >

                        <input
                          required
                          id="password"
                          v-model="password"
                          type="password"
                          placeholder="Password"
                          class="border border-gray-200 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                        />
                      </div>
                      <div class="flex flex-col gap-3">
                        <label for="Port" class="text-sm flex gap-2"
                          >Port
                        </label>

                        <select
                          id="Port"
                          v-model="Port"
                          class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                        >
                          <option value="" selected>Select port</option>
                          <option value="465">465 (SSL)</option>
                          <option value="587">587 (TLS)</option>
                          <option value="25">25 (Unsecured)</option>
                        </select>
                      </div>
                      <div class="flex mt-6 items-center gap-2">
                        <input
                          type="checkbox"
                          id="Published"
                          v-model="Published"
                        />
                        <label for="Published" class="text-sm">Published</label>
                      </div>
                      <div class="flex justify-center pb-4 mt-3 gap-10">
                        <button
                          @click="this.editEmail = false"
                          class="border text-gray-500 rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                        >
                          Close
                        </button>
                        <div class="flex justify-end items-center gap-3">
                          <button
                            type="submit"
                            :disabled="disable_submit == true"
                            :class="
                              this.disable_submit == true
                                ? 'bg-gray-200 text-black cursor-not-allowed'
                                : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                            "
                            class="rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                          >
                            Submit
                          </button>
                          <img
                            v-if="disable_submit"
                            src="@/assets/loading.gif"
                            alt="loading"
                            class="w-6 h-6 object-contain"
                          />
                        </div>
                        <!-- <button
                          type="submit"
                          :disabled="!isAfterSix"
                          @click="handleClick"
                          class="text-white bg-blues rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                        >
                          Submit
                        </button> -->
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <!-- Add metting popup -->
            <div
              v-if="this.addMeet"
              class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
            >
              <div
                class="lg:w-[30%] bg-white rounded-xl p-5 overflow-y-auto max-h-[600px]"
              >
                <div class="flex items-center justify-center">
                  <h3 class="text-xl font-bold text-blues text-center">
                    Add Metting Credentials
                  </h3>
                </div>

                <div
                  class="w-full mt-4 flex flex-col p-6 relative border-gray-100 rounded-2xl"
                >
                  <div class="w-full">
                    <form
                      ref="createTeamRef"
                      @submit.prevent="createSyllabus"
                      class="flex flex-col gap-2 text-xs md:text-sm lg:text-base h-full"
                    >
                      <div class="flex flex-col gap-3">
                        <label for="Types" class="text-sm flex gap-2"
                          >Types
                        </label>

                        <select
                          id="Types"
                          v-model="selectedType"
                          class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                        >
                          <option value="" selected>Select Type</option>
                          <option value="Gmail">Gmail</option>
                          <option value="Google">Google</option>
                        </select>
                      </div>
                      <div
                        v-if="selectedType === 'Gmail'"
                        class="flex flex-col gap-3"
                      >
                        <div>
                          <label for="option1" class="text-sm"
                            >Gmail Option 1</label
                          >
                          <select
                            id="option1"
                            class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                          >
                            <option value="" selected>Select Option 1</option>
                            <option value="imap">IMAP</option>
                            <option value="smtp">SMTP</option>
                          </select>
                        </div>

                        <div>
                          <label for="option2" class="text-sm"
                            >Gmail Option 2</label
                          >
                          <select
                            id="option2"
                            class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                          >
                            <option value="" selected>Select Option 2</option>
                            <option value="port465">Port 465</option>
                            <option value="port587">Port 587</option>
                          </select>
                        </div>
                      </div>
                      <div
                        v-if="selectedType === 'Google'"
                        class="flex flex-col gap-3"
                      >
                        <div>
                          <label for="option1" class="text-sm"
                            >Gmail Option 1</label
                          >
                          <select
                            id="option1"
                            class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                          >
                            <option value="" selected>Select Option 1</option>
                            <option value="imap">IMAP</option>
                            <option value="smtp">SMTP</option>
                          </select>
                        </div>

                        <div>
                          <label for="option2" class="text-sm"
                            >Gmail Option 2</label
                          >
                          <select
                            id="option2"
                            class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                          >
                            <option value="" selected>Select Option 2</option>
                            <option value="port465">Port 465</option>
                            <option value="port587">Port 587</option>
                          </select>
                        </div>
                        <div class="flex mt-6 items-center gap-2">
                          <input type="checkbox" id="Published" />
                          <label for="Published" class="text-sm"
                            >Published</label
                          >
                        </div>
                      </div>
                      <div class="flex justify-center pb-4 mt-3 gap-10">
                        <button
                          @click="
                            this.addMeet = false;
                            this.selectedType = '';
                          "
                          class="border text-gray-500 rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                        >
                          Close
                        </button>
                        <div class="flex justify-end items-center gap-3">
                          <button
                            type="submit"
                            :disabled="disable_submit == true"
                            :class="
                              this.disable_submit == true
                                ? 'bg-gray-200 text-black cursor-not-allowed'
                                : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                            "
                            class="rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                          >
                            Submit
                          </button>
                          <img
                            v-if="disable_submit"
                            src="@/assets/loading.gif"
                            alt="loading"
                            class="w-6 h-6 object-contain"
                          />
                        </div>
                        <!-- <button
                          type="submit"
                          class="text-white bg-blues rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                        >
                          Submit
                        </button> -->
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import SideBar from "@/components/Admin/SideBar.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  components: {
    Header,
    SideBar,
  },
  data() {
    return {
      activeTab: "email",
      addEmail: false,
      editEmail: false,
      addMeet: false,
      selectedType: "",
      datas: [
        {
          type: "IMAP",
          email: "imap.example.com",
          port: 993,
          is_active: false,
        },
        {
          type: "SMTP",
          email: "smtp.example.com",
          port: 587,
          is_active: false,
        },
        {
          type: "POP3",
          email: "pop3.example.com",
          port: 995,
          is_active: false,
        },
        {
          type: "",
          email: "",
          port: "",
          is_active: false,
        },
      ],
      showPopup: false,
      pendingItem: null,
      dep_email: "",
      checkbox_status: false,
      editEmailId: null,
      currentTime: new Date(),
      disable_submit: false,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    isAfterSix() {
      const now = this.currentTime;
      return now.getHours() >= 18; // 18 means 6 PM
    },
  },
  created() {},
  methods: {
    setTab(tab) {
      this.activeTab = tab;
    },
    handleToggle(item) {
      if (item) {
        this.pendingItem = item;
        this.dep_email = item.email;
        this.showPopup = true;
        if (item.is_active == true) {
          this.checkbox_status = false;
        } else {
          this.checkbox_status = true;
        }
      }
    },
    cancelToggle() {
      this.pendingItem = null;
      this.showPopup = false;
    },
    openEditPopup(id) {
      this.editEmailId = id;
      //   axios
      //     .get(
      //       `${process.env.VUE_APP_API}/syllabus-overall-list/?Key=${this.userInfo.token_key}&id=${id}`
      //     )
      //     .then((response) => {
      //       if (response.data.data.status == 200) {
      //         this.editsyllabus_list = response.data.data.data[0];
      //       } else {
      //         console.log("got error");
      //       }
      //     });

      this.editEmail = true;
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
